import { Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { CircularProgress, Tooltip, Select, MenuItem, FormControl, InputAdornment, TextField, Button, 
    TableContainer, Table, TableHead, TableBody, Paper, TablePagination, Dialog, 
    DialogActions, DialogContent, DialogContentText, DialogTitle, Box, FormHelperText,
    FormLabel, FormGroup, FormControlLabel, Checkbox} from '@mui/material';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { post } from '../../../../src/services/http';
import { ContextSession } from "../../../services/ContextSession";
import FilterListIcon from '@mui/icons-material/FilterList';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import CryptoJS from 'crypto-js';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useNavigate } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HandymanIcon from '@mui/icons-material/Handyman';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import {
    exportConstanciasToExcel,
    fetchUsuariosSecretariaGeneral,
} from './exportConstanciasExcel';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#19438C',
        color: 'white',
        fontSize: 16,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        borderRight: 'none', // Elimina la línea vertical entre columnas
        borderLeft: 'none', // Elimina la línea vertical entre columnas
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
    '&:hover': { // Agrega estilo al pasar el cursor sobre la fila
        backgroundColor: '#C1C1C1', // Cambia el color de fondo al pasar el cursor
    },
}));

function ListaSolConstanciasAprobadasSG() {
    let sessi = useContext(ContextSession);
    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(true);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [searchTerm, setSearchTerm] = useState('');
    const [loanType, setLoanType] = useState('');
    const [statusFilter, setStatusFilter] = useState('2');
    const [searchDNI, setSearchDNI] = useState('');
    const handleSearchDNIChange = (event) => setSearchDNI(event.target.value);
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [usuariosSG, setUsuariosSG] = useState([]);
    const estadosConstancia = {
        1: "PENDIENTE",
        2: "PAGADA",
        3: "CANCELADA",
        4: "EMITIDA",
        5: "ANULADA"
    };

    const tiposConstancia = {
        1: "HISTORIAL DE COTIZACIONES",
        2: "RAZONADA",
        3: "SALDOS PROYECTADOS",
        4: "NO TENER PRÉSTAMO ACTIVO",
        5: "TRÁMITE EMBAJADA"
    };

    // NUEVO: estados para dialog y fila seleccionada
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [patchLoading, setPatchLoading] = useState(false);
    const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
    const [openDialogSubsanar, setOpenDialogSubsanar] = useState(false);
    const [openSuccessDialogSubsanar, setOpenSuccessDialogSubsanar] = useState(false);
    const [observacion, setObservacion] = useState("");
    const [camposSeleccionados, setCamposSeleccionados] = useState({
        copiaDNI: false,
        copiaConstancia: false,
    });
    const [errorObservacion, setErrorObservacion] = useState(false);
    const [errorDocumentos, setErrorDocumentos] = useState(false);
    const [formValido, setFormValido] = useState(false);

    useEffect(() => {
            const documentosValidos = camposSeleccionados.copiaDNI || camposSeleccionados.copiaConstancia;
            const observacionValida = observacion.trim().length > 0;
            
            setErrorDocumentos(!documentosValidos);
            setErrorObservacion(!observacionValida);
            setFormValido(documentosValidos && observacionValida);
      }, [camposSeleccionados, observacion]);

    // 1. Mueve fetchData fuera de useEffect
    const fetchData = async () => {
        setLoading(true);
        try {
            const secretKey = "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8";
            const queryString = `IdEstado=${statusFilter}`;
            const signature = CryptoJS.HmacSHA256(queryString, secretKey).toString(CryptoJS.enc.Hex);

            //const response = await fetch(`https://be.injupemp.gob.hn:8443/api/ConstanciaPag/ConstanciaOper/?IdEstado=${statusFilter}`, {
            const response = await fetch(`http://172.20.7.10:8082/api/ConstanciaPag/ConstanciaOper/?IdEstado=2`, {
                method: "GET",
                headers: {
                    "X-Signature": signature,
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) throw new Error("Error al obtener los datos");
            const data = await response.json();
            //console.log(data)
            setRows(data);
        } catch (error) {
            setRows([]);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchData();
    }, [statusFilter]);

    useEffect(() => {
        const fetchUsuariosSG = async () => {
            const data = await fetchUsuariosSecretariaGeneral();
            setUsuariosSG(data);
        };

        fetchUsuariosSG();
    }, []);

    const handleChangePage = (event, newPage) => setPage(newPage);
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const filteredRows = rows
        .filter(row => row.fk_id_estado === 2 /*&& row.secretariaGeneralAprobado === null*/);

    const handleDownloadExcel = () => {
        exportConstanciasToExcel({
            rows: filteredRows,
            bandeja: "Pagadas",
            tiposConstancia,
            estadosConstancia,
            includeAprobadoPor: true,
            usuariosSG,
        });
    };

    // --- Función para abrir el dialog ---
    const handleOpenDialog = (row) => {
        setSelectedRow(row);
        setOpenDialog(true);
    };

    // 2. PATCH y dialog de éxito
    const handleAccept = async () => {
        if (!selectedRow) return;
        setPatchLoading(true);
        try {
            const secretKey = "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8";
            const idSolicitud = selectedRow.id_solicitud_constancia;
            const idUser = sessi.sessionData.id;
            const queryString = `IdSolicitud=${idSolicitud}`;
            const signature = CryptoJS.HmacSHA256(queryString, secretKey).toString(CryptoJS.enc.Hex);
            const url = `http://172.20.7.10:8082/api/ConstanciaPag/ConstanciaSG/Aprobar/?IdSolicitud=${idSolicitud}&IdUserSG=${idUser}`;
            //const url = `https://be.injupemp.gob.hn:8443/api/ConstanciaPag/ConstanciaSG/Aprobar/?IdSolicitud=${idSolicitud}&IdUserSG=${idUser}`;

            const response = await fetch(url, {
                method: "PATCH",
                headers: {
                    "X-Signature": signature,
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) throw new Error("Error al aprobar la solicitud");
            // CIERRA el dialog y muestra el de éxito
            setOpenDialog(false);
            setOpenSuccessDialog(true);
        } catch (error) {
            alert("Ocurrió un error al aprobar la solicitud.");
        }
        setPatchLoading(false);
    };

    // 3. Cuando el usuario acepta el dialog de éxito, cierra el dialog y actualiza la tabla
    const handleSuccessDialogClose = () => {
        setOpenSuccessDialog(false);
        fetchData();
    };

    ////////////////////////////////////////////////////////////////////////////////////// SUBSANAR
    
        const handleOpenDialogSubsanar = (row) => {
            setSelectedRow(row);
            setOpenDialogSubsanar(true);
        };
    
        // 2. PATCH y dialog de SUBSANAR
        const handleAcceptSubsanar = async () => {
            if (!selectedRow) return;
            setPatchLoading(true);
            try {
                const campos = [];
                if (camposSeleccionados.copiaDNI) campos.push("CopiaDNI");
                if (camposSeleccionados.copiaConstancia) campos.push("CopiaConstancia");
                const camposString = campos.join(",");
    
                const secretKey = "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8";
                const idSolicitud = selectedRow.id_solicitud_constancia;
               // const idUser = sessi.sessionData.id;
    
               /*const requestBody = {
                Observacion: observacion, // Usa el estado en lugar de un texto fijo
                campos: camposString, // Ajusta según lo que necesites
                IdSolicitud: idSolicitud,
                //IdUserSG: idUser,
                };*/
    
                const formData = new FormData();
                formData.append('Observacion', observacion);
                formData.append('Campos', camposString);
                formData.append('IdSolicitud', idSolicitud);
    
                const queryString = `IdSolicitud=${idSolicitud}`;
                const signature = CryptoJS.HmacSHA256(queryString, secretKey).toString(CryptoJS.enc.Hex);
                const url = `http://172.20.7.10:8082/api/ConstanciaPag/Habilitar/Subsanacion/`;
                //const url = `https://be.injupemp.gob.hn:8443/api/ConstanciaPag/ConstanciaSG/Aprobar/?IdSolicitud=${idSolicitud}&IdUserSG=${idUser}`;
    
                const response = await fetch(url, {
                    method: "PATCH",
                    headers: {
                        "X-Signature": signature,
                    },
                    body: formData
                });
    
                if (!response.ok) throw new Error("Error al aprobar la solicitud");
                // CIERRA el dialog y muestra el de éxito
                setOpenDialogSubsanar(false);
                setOpenSuccessDialogSubsanar(true);
            } catch (error) {
                alert("Ocurrió un error al aprobar la solicitud.");
            }
            setPatchLoading(false);
        };
    
        // 3. Cuando el usuario acepta el dialog de éxito, cierra el dialog y actualiza la tabla
        const handleSuccessDialogSubsanarClose = () => {
            setOpenSuccessDialogSubsanar(false);
            fetchData();
            setObservacion("");
            setCamposSeleccionados({ copiaDNI: false, copiaConstancia: false });
        };
    
    
        // 3. Cuando el usuario acepta el dialog de éxito, cierra el dialog y actualiza la tabla
        const handleCloseDialogSubsanar = () => {
            setOpenDialogSubsanar(false);
            fetchData();
            setObservacion("");
            setCamposSeleccionados({ copiaDNI: false, copiaConstancia: false });
        };
    
    
        //////////////////////////////////////////////////////////////////////////////////////

    const handleClick = (id) => {
        sessi.setVariable("IDsolConstanciaSG", id);
        navigate('/PortalDelParticipante/VerSolicitudConstanciaSG');
    };

    return (
        <div className="container" style={{ marginTop: 10 }}>
            <>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 10 }}>
                    <h2><b>Lista de Solicitudes de Constancias Pagadas</b></h2>
                </div>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2, mt: 1 }}>
                    <Tooltip
                        title={
                            filteredRows.length
                                ? "Descargar bandeja actual en Excel"
                                : "No hay datos para exportar"
                        }
                        arrow
                    >
                        <span>
                            <Button
                                variant="contained"
                                color="success"
                                startIcon={<FileDownloadIcon />}
                                onClick={handleDownloadExcel}
                                disabled={loading || filteredRows.length === 0}
                            >
                                Descargar Excel
                            </Button>
                        </span>
                    </Tooltip>
                </Box>

                <div className="row" style={{ marginTop: '20px' }}>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell>#</StyledTableCell>
                                    <StyledTableCell>DNI Solicitante</StyledTableCell>
                                    <StyledTableCell>Solicitante</StyledTableCell>
                                    <StyledTableCell>Nº Recibo</StyledTableCell>
                                    <StyledTableCell>Tipo Constancia</StyledTableCell>
                                    <StyledTableCell>Monto</StyledTableCell>
                                    <StyledTableCell>Fecha Registro</StyledTableCell>
                                    <StyledTableCell>Fecha Pagado</StyledTableCell>
                                    <StyledTableCell>Detalle Solicitud</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>Acciones</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>

                            <TableBody>
                                {loading ? (
                                    <StyledTableRow>
                                        <StyledTableCell colSpan={11} align="center">
                                            <CircularProgress size={24} />
                                        </StyledTableCell>
                                    </StyledTableRow>
                                ) : filteredRows && filteredRows.length > 0 ? (
                                    filteredRows
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((row, idx) => (
                                            <StyledTableRow key={row.id_solicitud_constancia}>
                                                <StyledTableCell>{page * rowsPerPage + idx + 1}</StyledTableCell>
                                                <StyledTableCell>{row.DNI_usuario}</StyledTableCell>
                                                <StyledTableCell>{row.NombreCompleto_usuario}</StyledTableCell>
                                                <StyledTableCell>{row.numero_recibo}</StyledTableCell>
                                                <StyledTableCell>
                                                    {tiposConstancia[row.fk_id_constancia] || "DESCONOCIDO"}
                                                </StyledTableCell>
                                                <StyledTableCell>L.{row.monto}</StyledTableCell>
                                                <StyledTableCell>
                                                    {row.fecha_registro ? row.fecha_registro.split("T")[0] + " " + row.fecha_registro.split("T")[1].substring(0, 8) : "-"}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    {row.fecha_pagada ? row.fecha_pagada.split("T")[0] + " " + row.fecha_pagada.split("T")[1].substring(0, 8) : "-"}
                                                </StyledTableCell>
                                                <StyledTableCell>{row.detalle_solicitud}</StyledTableCell>
                                                <StyledTableCell>
                                                    <Box display="flex" justifyContent="center">

                                                        <Tooltip title="Ver Solicitud" arrow placement="left-start">
                                                            <IconButton
                                                                onClick={() => handleClick(row.id_solicitud_constancia)}
                                                            >
                                                                <VisibilityIcon sx={{ color: 'green', fontSize: 30 }} />
                                                            </IconButton>
                                                        </Tooltip>

                                                        <Tooltip title="Enviar a Subsanar Solicitud" arrow placement="left-start">
                                                            <IconButton
                                                                onClick={() => handleOpenDialogSubsanar(row)}
                                                                disabled={patchLoading || row.fk_id_estado !== 2}
                                                            >
                                                                <HandymanIcon sx={{ color: row.fk_id_estado === 2 ? 'green' : 'grey' }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Box>
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        ))
                                ) : (
                                    <StyledTableRow>
                                        <StyledTableCell colSpan={11} align="center">
                                            No hay datos.
                                        </StyledTableCell>
                                    </StyledTableRow>
                                )}
                            </TableBody>

                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={filteredRows.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        labelRowsPerPage={"Filas por página"}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />

                </div>

                {/* DIALOG PARA SUBSANAR */}
                <Dialog open={openDialogSubsanar} onClose={() => setOpenDialogSubsanar(false)}>
                    <DialogTitle textAlign={'center'}>Enviar a Subsanar</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            ¿Está seguro de Enviar a Subsanar <b>{selectedRow && tiposConstancia[selectedRow.fk_id_constancia]} </b>
                            con N° Recibo <b>{selectedRow && selectedRow.numero_recibo}</b> de parte de <b>{selectedRow && selectedRow.NombreCompleto_usuario}</b>?
                        </DialogContentText >
                        <TextField
                            multiline
                            rows={4}
                            autoFocus
                            margin="dense"
                            label="Observación"
                            type="text"
                            fullWidth
                            variant="outlined"
                            value={observacion} // Estado para almacenar la observación
                            onChange={(e) => setObservacion(e.target.value)}
                            error={errorObservacion}
                            helperText={errorObservacion? "La observación es obligatoria" : ""}
                            required // Hacer obligatorio
                        />
                        <FormControl component="fieldset" sx={{ mt: 2 }} error={errorDocumentos}>
                            <FormLabel component="legend">Documentos a Subsanar:</FormLabel>
                            <Box 
                                sx={{ 
                                    border: errorDocumentos ? '1px solid #d32f2f' : '1px solid rgba(0, 0, 0, 0.23)',
                                    borderRadius: 1,
                                    p: 2,
                                    backgroundColor: errorDocumentos ? '#fff5f5' : 'transparent'
                                }}
                                >
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={camposSeleccionados.copiaDNI}
                                            onChange={(e) => setCamposSeleccionados({
                                                ...camposSeleccionados,
                                                copiaDNI: e.target.checked,
                                            })}
                                        />
                                    }
                                    label="Copia de DNI"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={camposSeleccionados.copiaConstancia}
                                            onChange={(e) => setCamposSeleccionados({
                                                ...camposSeleccionados,
                                                copiaConstancia: e.target.checked,
                                            })}
                                        />
                                    }
                                    label="Copia de Constancia"
                                />
                            </FormGroup>
                            </Box>
                            {errorDocumentos && (
                                <Typography variant="caption" color="error" sx={{ mt: 1, display: 'block' }}>
                                Debe seleccionar al menos un documento a subsanar
                                </Typography>
                            )}
                        </FormControl>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseDialogSubsanar} color="error" disabled={patchLoading}>No</Button>
                        <Button onClick={handleAcceptSubsanar} color="primary" variant="contained" disabled={errorObservacion ||  errorDocumentos}>
                            {patchLoading ? <CircularProgress size={18} /> : "Sí"}
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* DIALOG DE ÉXITO */}
                <Dialog open={openSuccessDialogSubsanar} onClose={handleSuccessDialogSubsanarClose}>
                    <DialogTitle>
                        <Box display="flex" alignItems="center" justifyContent="center">
                            <span style={{ fontWeight: 500 }}>Solicitud Enviada</span>
                            <CheckCircleIcon style={{ color: 'green', marginLeft: 10 }} />
                        </Box>
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText textAlign={'justify'}>
                            La solicitud de constancia se envío a Subsanar con éxito y fue enviada al participante.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions sx={{ justifyContent: "center" }}>
                        <Button
                            onClick={handleSuccessDialogSubsanarClose}
                            color="primary"
                            variant="contained"
                            sx={{ mx: "auto", minWidth: 120 }}
                        >
                            Aceptar
                        </Button>
                    </DialogActions>
                </Dialog>
            </>
        </div>
    );
}

export default ListaSolConstanciasAprobadasSG;
